(() => {
  const STORAGE_KEY = 'guidewill:wishlist';

  const readWishlist = () => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      // Browsing can continue when storage is unavailable.
    }
  };

  const syncButtons = () => {
    const handles = new Set(readWishlist().map((item) => item.handle));
    document.querySelectorAll('[data-guidewill-wishlist]').forEach((button) => {
      const active = handles.has(button.dataset.productHandle);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      const label = button.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? button.dataset.removeLabel : button.dataset.addLabel;
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-guidewill-wishlist]');
    if (!button) return;

    const items = readWishlist();
    const index = items.findIndex((item) => item.handle === button.dataset.productHandle);
    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.push({
        handle: button.dataset.productHandle,
        title: button.dataset.productTitle,
        url: button.dataset.productUrl,
        image: button.dataset.productImage || ''
      });
    }
    writeWishlist(items);
    syncButtons();
  });

  const bindProductsPerPage = () => {
    document.querySelectorAll('[data-products-per-page]').forEach((select) => {
      if (select.dataset.bound === 'true') return;
      select.dataset.bound = 'true';
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        if (select.value) url.searchParams.set('view', select.value);
        else url.searchParams.delete('view');
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    syncButtons();
    bindProductsPerPage();
  });
  document.addEventListener('shopify:section:load', syncButtons);
})();
